import { Tooltip } from "@frends/ui-components/react";

export default Tooltip;
